<template>
    <div id="quotations-page">
        <spinner-text v-if="loading">
            {{ trans('pages.quotations.loading') }}
        </spinner-text>
        <div
            class="error"
            v-else-if="errorLoading"
        >
            {{ trans('pages.quotations.error_loading') }}
        </div>
        <template v-else>
            <div class="orders-title">
                {{ trans('pages.quotations.title') }}
                <template v-if="visibleOrders">
                    ({{ visibleOrders.length }})
                </template>
            </div>

            <div class="selector-container">
                <ui5-select
                    @change="
                        filters.customerType =
                            $event.detail.selectedOption.value
                    "
                >
                    <ui5-option
                        :value="-1"
                        :selected="filters.customerType == -1"
                    >
                        {{ trans('pages.quotations.all') }}
                    </ui5-option>
                    <ui5-option
                        v-for="type in usedTypes"
                        :selected="filters.customerType == type.id"
                        :value="type.id"
                        :key="'customerType.' + type.id"
                    >
                        {{ type.label }}
                    </ui5-option>
                </ui5-select>
                <ui5-select
                    @change="
                        filters.orderType = $event.detail.selectedOption.value
                    "
                >
                    <ui5-option
                        :value="-1"
                        :selected="filters.orderType == -1"
                    >
                        {{ trans('pages.quotations.all') }}
                    </ui5-option>
                    <ui5-option
                        v-for="type in orderTypes || []"
                        :key="'orderType.' + type"
                        :selected="filters.orderType == type"
                        :value="type"
                    >
                        {{ type }}
                    </ui5-option>
                </ui5-select>
            </div>

            <ui5-list v-if="visibleOrders">
                <ui5-li
                    v-for="order in visibleOrders"
                    @click="goToOrder(order.orderId)"
                    :key="'manualOrder.' + order.orderId"
                    :description="order.customerName + ' - ' + order.insertDate"
                    :additional-text="
                        order.waitForOrderConfirmation
                            ? trans('pages.quotations.waiting_confirmation')
                            : ''
                    "
                    additional-text-state="Warning"
                >
                    {{ order.orderId }}
                    {{ order.reference1 }}
                </ui5-li>
            </ui5-list>
        </template>
    </div>
</template>
<script>
import { clearedFilters } from '../shared/newOrders';
import orderApi from '../api/order';
import productApi from '../api/product';
import SpinnerText from '../components/loader/SpinnerText';
import Spinner from '../components/loader/Spinner';
import { showInfoMessage, showErrorMessage } from '../dialogs';
import _ from 'lodash';
import localization from '../mixins/localization';

export default {
    components: { Spinner, SpinnerText },
    mixins: [localization],
    computed: {
        usedTypes() {
            if (!this.customerTypes || !this.orders) {
                return [];
            }
            const usedIds = _.uniq(this.orders.map((x) => x.customerType));
            return this.customerTypes.filter((type) => {
                return usedIds.includes(type.ID);
            });
        },
        visibleOrders() {
            if (!this.orders) {
                return [];
            }
            return this.orders.filter((order) => {
                return (
                    (this.filters.customerType == -1 ||
                        this.filters.customerType == order.customerType) &&
                    (this.filters.orderType == -1 ||
                        this.filters.orderType == order.type)
                );
            });
        },
        filters: {
            get() {
                return this.$store.getters['newOrders/getFilters'];
            },
            set(value) {
                this.$store.commit('newOrders/setFilters', value, {
                    root: true,
                });
            },
        },
    },
    data() {
        return {
            loading: false,
            errorLoading: false,
            orders: null,
            customerTypes: null,
            orderTypes: null,
        };
    },
    methods: {
        goToOrder(orderId) {
            this.$store.commit('general/setOrderId', orderId, { root: true });
            this.$router.push('/editproduct/?orderId=' + orderId);
        },
        load() {
            this.loading = true;
            this.errorLoading = false;
            orderApi
                .quotations()
                .then((response) => {
                    const data = response.data.data;
                    this.orders = data.orders;
                    this.customerTypes = data.customerTypes;
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.quotations.error_loading')
                    );
                    this.errorLoading = true;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    mounted() {
        orderApi.fetchAllOrderTypes().then((request) => {
            this.orderTypes = request.data.data;
        });

        this.load();
    },
};
</script>
